<template>
  <section class="member-lesson-player inner">
    <section class="category-wrap">
        <div class="category-div" v-if="category_list != undefined">
            <span class="cat_1" v-if="category1!=''">{{ getCategoryTitle('category1') }}</span><span class="cat_2" v-if="category2!=''">{{ getCategoryTitle('category2') }}</span>
            <span class="cat_1" v-if="category1=='' && category2==''">全て</span>
        </div>
    </section>

    <div class="lesson-video-player">
      <div class="player" v-show="content_type=='video'">
        <video id="video01" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" data-setup="{}" controls preload="auto" playsinline></video>
      </div>
      <div class="player" v-show="content_type=='music'">
        <audio class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" data-setup="{}" controls preload="auto" :poster="'/item/image/'+item_id" id="audio-player" playsinline></audio>
      </div>
      <div class="data">
        <h3 class="video-title">{{ content_title }}</h3>
        <p class="sub-title">{{ item_title }}</p>
        <p class="sub-explain" v-html="item_description"></p>
        <div class="video-button-set">

          <button
            v-if="contents.length"
            class="swh_button"
            :class="{ 'add_on': contents[playing_number].favorite_status == 1 }"
            @click="contents[playing_number].favorite_status == 0 ? addFavoriteList(playing_number) : removeFavoriteList(playing_number)"
            >
            <span class="icon"></span><span>FEVORITE</span>
          </button>

            <div class="repeat-new" :class="{ 'add_on': repeat_flag }">
                <button class="swh_button" @click="changeRepeatFlag">
                    <span class="icon"></span><span>REPEAT</span>
                </button>
            </div>

            <div class="auto-new" :class="{ 'add_on': auto_play_flag }">
                <button class="swh_button" @click="changeAutoPlayFlag">
                    <span class="icon"></span><span>AUTO</span>
                </button>
            </div>

        </div>
      </div>
    </div>

    <div class="lesson-video-related">
      <h3 class="in-title">関連動画</h3>
      <ul class="lesson-video-list">

        <li class="mem-video-item" v-for="(random_video, index) in random_video_list" v-show="loaded_list.includes(index)">
          <a :href="`/purchased/player/${random_video.digicon_id}?${category_query}`" class="cvr"></a>
          <div class="thumb">
            <figure><img :src="'/item/image/'+random_video.item_id" alt=""></figure>
          </div>
          <div class="lesson-data">
            <div class="in_head">
              <h3 class="lesson-title">{{ random_video.title }}</h3>
              <p class="post-date">{{ random_video.up }}公開</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
    import 'video.js/dist/video-js.css';
    import videojs from 'video.js/dist/video.js';
    export default {
        name: "azenc-video-player",
        props: {
            first_item_id: {
                type: String,
                default: '0',
            },
            first_digicon_id: {
                type: String,
                default: '0',
            },
            category1: {
                type: String,
                default: '',
            },
            category1_child: {
                type: String,
                default: '',
            },
            category2: {
                type: String,
                default: '',
            },
            category2_child: {
                type: String,
                default: '',
            },
            fav_trans_flag: {
                type: Number,
                default: 0,
            },
            def_auto_play_flag: {
                type: Number,
                default: 0,
            },
            play_type: {
                type: String,
                default: 'video',
            },
        },
        data: function () {
            return {
                item_id: 0,
                digicon_id: 0,
                video: undefined,
                audio: undefined,
                content_title: '',
                item_title: '',
                contents: [],
                playing_number: Number,
                playStartSec: 0,
                repeat_flag: false,
                recordedFlag: false,
                finFlag: false,
                sample_flag: 0,
                loaded_list: [],
                random_video_list: [],
                auto_play_flag: false,
                next_item_id: 0,
                next_digicon_id: 0,
                next_item_id: 0,
                content_type: '',
                category_query: '',
                category_list: undefined,
            }
        },
        created() {
            this.auto_play_flag = this.def_auto_play_flag==1?true:false;
        },
        mounted() {
            console.log(`first_item_id=${this.first_item_id}, first_digicon_id=${this.first_digicon_id}`);
            this.item_id = Number(this.first_item_id);
            this.digicon_id = Number(this.first_digicon_id);
            this.category_query = `category1=${this.category1}&category1_child=${this.category1_child}&category2=${this.category2}&category2_child=${this.category2_child}`;

            this.video = videojs("video01", {html5: {
                }},
            );
            this.audio = videojs("audio-player", {html5: {
                }},
            );
            this.setVideoConfig();
            this.setAudioConfig();
            this.getAlbumInfo();
            this.getRandomVideoList();
            this.getCategoryList();
        },
        methods: {
            play: function() {
                if(this.finFlag) {
                    this.finFlag = false;
                    this.playing_number = 0;
                    this.setDigicon(this.playing_number);
                    return;
                }
                if(this.content_type == 'video') {
                    this.video.play();
                } else {
                    this.audio.play();
                }
                this.resetPlayingSec();
            },
            stop: function() {
                if(this.content_type == 'video') {
                    this.video.pause();
                } else {
                    this.audio.pause();
                }
            },
            setVideoConfig: function() {
                this.video.on('loadedmetadata', function() {
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                    this.play();
                }.bind(this));
                this.video.on('timeupdate', function() {
                    this.recordPlayLog();
                }.bind(this));
                this.video.on('ended', function() {
                    this.forward();
                }.bind(this));
            },
            setAudioConfig: function() {
                this.audio.on('loadedmetadata', function() {
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                    this.play();
                }.bind(this));
                this.audio.on('timeupdate', function() {
                    this.recordPlayLog();
                }.bind(this));
                this.audio.on('ended', function() {
                    this.forward();
                }.bind(this));
            },
            setDigiconConfig: function(path) {
                console.log(`play digicon_id=${this.digicon_id}, type=${this.content_type}`);
                if(this.content_type == 'video') {
                    this.video.src(path);
                } else {
                    const poster = document.getElementsByClassName("vjs-poster")[1];
                    poster.style.backgroundImage = "url("+`/item/image/${this.item_id}`+")";
                    this.audio.src(path);
                }
            },
            setDigicon: function(playing_number) {
                if(this.contents.length <= playing_number) {
                    this.playing_number = 0;
                    playing_number = this.playing_number;
                }
                this.content_title = this.contents[playing_number].title;
                let digicon_id = this.contents[playing_number].digicon_id;
                this.item_title = this.contents[playing_number].item_title;
                this.item_description = this.contents[playing_number].item_description;
                this.content_type = this.contents[playing_number].type;
                console.log(`content_type=${this.content_type}`);
                axios.default
                    .get('/digicon/content/'+digicon_id)
                    .then(response => {
                        let data = response.data;
                        let playing_path = data.fname;
                        this.setDigiconConfig(playing_path);
                    });
            },
            getAlbumInfo: function() {
                axios.default
                    .post('/purchased/digicon/detail/'+this.item_id, {type: 'content'})
                    .then(response => {
                        let contents = response.data;
                        // for(let i=0; i<contents.length; i++) {
                        //     // this.$set(this.contents, i, contents[i]);
                        // }
                        this.contents = contents;
                        this.jump(this.digicon_id);
                        this.getNextContentInfo();
                });
            },
            getNextContentInfo: function() {
                axios.default
                    .get(`/next_play/digicon_id/get?digicon_id=${this.digicon_id}&${this.category_query}&fav_trans_flag=${this.fav_trans_flag}`)
                    .then(response => {
                        let ret = response.data;
                        this.next_item_id = ret.item_id;
                        this.next_digicon_id = ret.digicon_id;
                });
            },
            forward: function() {
                this.stop();
                if(this.repeat_flag !== true) {
                    if(this.contents.length-1 <= this.playing_number) {
                        this.finFlag = true;
                        if(this.auto_play_flag && this.next_item_id!=0) {
                            console.log(`item_id=${this.item_id}, next_item_id=${this.next_item_id}`);
                            console.log(`digicon_id=${this.digicon_id}, next_digicon_id=${this.next_digicon_id}`);
                            this.item_id = Number(this.next_item_id);
                            this.digicon_id = Number(this.next_digicon_id);
                            this.getAlbumInfo();
                        }
                        return;
                    } else {
                        this.playing_number++;
                    }
                }
                this.setDigicon(this.playing_number);
            },
            jump: function(digicon_id) {
                this.stop();
                let index = 0;
                for(let content of this.contents) {
                    console.log(`jump content.digicon_id=${content.digicon_id}, digicon_id=${digicon_id}`);
                    if(content.digicon_id == digicon_id) {
                        console.log(`jump index=${index}`);
                        this.playing_number = index;
                        this.finFlag = false;
                        this.setDigicon(this.playing_number);
                        break;
                    }
                    index++;
                }
            },
            changeRepeatFlag() {
                this.repeat_flag = !this.repeat_flag;
            },
            changeAutoPlayFlag: function() {
                this.auto_play_flag = (this.auto_play_flag)?false:true;
            },
            resetPlayingSec: function() {
                this.playStartSec = performance.now();
            },
            recordPlayLog: function() {
                if(!this.checkPlayingSec()) return;
                if(this.recordedFlag) return;
                this.recordedFlag = true;
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .post('/player/log/add', {digicon_id: digicon_id})
                    .then(response => {
                        if(response.data.status=='error') {
                            this.recordedFlag = false;
                        }
                    });
            },
            recordContentsPlayLog: function() {
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .get('/playlog/content/add/'+digicon_id, {sample_flag: this.sample_flag})
                    .then(response => {
                        if(!response.data[0].log_id) {
                            console.log('fail record playlog');
                        }
                    });
            },
            checkPlayingSec: function() {
                if(performance.now() - this.playStartSec < 46000) return false;
                return true;
            },
            addFavoriteList: function(index) {
                let digicon_id = this.contents[index]['digicon_id'];
                axios.default
                    .get('/favorite/content/add/'+digicon_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 1;
                        this.contents[index]['favorite_id'] = res.favorite_id;
                    });
            },
            removeFavoriteList: function(index) {
                let favorite_id = this.contents[index]['favorite_id'];
                axios.default
                    .get('/favorite/content/remove/'+favorite_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 0;
                        this.contents[index]['favorite_id'] = undefined;
                    });
            },
            getRandomVideoList: function() {
                let path = '';
                if(this.play_type=='video') {
                    path = '/movie/get/random';
                } else if(this.play_type=='music') {
                    path = '/voice/get/random';
                }
                axios.default
                    .get(`${path}?item_id=${this.item_id}&${this.category_query}`)
                    .then(response => {
                        this.random_video_list = response.data;
                    });
            },
            addImageLoadedList: function(index) {
                this.loaded_list.push(index);
            },
            getCategoryList: function() {
                axios.default
                    .get(`/item/category/list/get?type=${this.play_type}`)
                    .then(response => {
                        this.category_list = response.data;
                    });
            },
            getCategoryTitle: function(category_type) {
                let category_num;
                let child_num;
                switch(category_type) {
                    case 'category1':
                        category_num = this.category1;
                        child_num = this.category1_child;
                        break;
                    case 'category2':
                        category_num = this.category2;
                        child_num = this.category2_child;
                        break;
                }
                if(category_num=='') {
                    return '全て';
                }
                const category_list = this.category_list[category_type];
                const category = category_list.find(element => element.id == category_num);
                if(category) {
                    const child = category['child'].find(element => element.id == child_num);
                    console.dir(child);
                    if(child) {
                        return child.title;
                    }
                    return category.title;
                }
                return '';
            },
        },
    }
</script>

<style scoped>
</style>
